import styled from 'styled-components'

import TextareaAutosize from 'react-textarea-autosize'

import colors, { FLAG_COLOURS, NEUTRAL_COLOURS } from 'constants/colors'
import layout from 'constants/layout'

export const StyledInputContainer = styled.div`
  position: relative;
`

interface StyledAutosizeTextAreaProps {
  $disabled?: boolean
  $height?: number
  $hidden?: boolean
  $padding?: string
  $valid?: boolean
  maxHeight?: string
}

export const StyledAutosizeTextArea = styled(TextareaAutosize)<StyledAutosizeTextAreaProps>`
  max-width: 100%;
  display: block;
  border-style: solid;
  border-width: 1px;
  border-color: ${({ $valid }) => (false === $valid ? FLAG_COLOURS.ERROR : colors.inputBorderColor)};
  border-radius: 4px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom: none;
  line-height: 20px;
  width: 100%;
  padding: 10px;
  font-size: 14px;
  resize: none;
  color: ${NEUTRAL_COLOURS.BASIC};
  transition: color .1s;

  ${({ $hidden }) => $hidden && `
    color: ${NEUTRAL_COLOURS.GRAY};
  `}

  ${({ $disabled }) => $disabled && `
    background-color: ${colors.disabled};
    cursor: not-allowed;

    &::-webkit-input-placeholder {
      color: #CCC;
    }
  `}

  @media(max-width: ${layout.mobileWidthResolution}px) {
    width: 100%;
  }
`

interface StyledFooterContainerProps {
  $isEnabled?: boolean
  $valid?: boolean
}

export const StyledFooterContainer = styled.div<StyledFooterContainerProps>`
  background: ${NEUTRAL_COLOURS.WHITE};
  border: 1px solid ${colors.inputBorderColor};
  border-color: ${({ $valid }) => (false === $valid ? FLAG_COLOURS.ERROR : colors.inputBorderColor)};
  border-top-color: transparent;
  border-radius: 4px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  padding: 10px;
  transition: border-top-color .1s;

  ${({ $isEnabled, $valid }) => $isEnabled && `
    border-top-color: ${false === $valid ? FLAG_COLOURS.ERROR : colors.inputBorderColor};
  `}
`

export const StyledAiIcon = styled.div`
  .webfont {
    background: linear-gradient(150deg, #EB24C8 0%, #5B68F5 75%, #6FD2F2 100%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`

interface StyledButtonContainerProps {
  $isEnabled?: boolean
}

export const StyledButtonContainer = styled.div<StyledButtonContainerProps>`
  display: flex;

  @media(max-width: ${layout.mobileWidthResolution}px) {
    & > div {
      display: grid;
      grid-template-columns: 1fr auto auto;
      width: 100%;

      ${({ $isEnabled }) => $isEnabled && `
        grid-template-rows: auto auto;
      `}
    }
  }
`
